/** @jsxImportSource @emotion/react */
import { createFileRoute } from '@tanstack/react-router'
import { loadAccountPackageAlias } from '#start/server/package-alias'
import { NotFoundPage } from '../components/not-found-page.tsx'
export const Route = createFileRoute('/account_/packages/$packageId')({
	staticData: {
		motionGroup: 'account',
		navigation: { rail: 'workspace', item: 'packages' },
	},
	loaderDeps: ({ search }) => search,
	loader: ({ abortController, params, location }) =>
		loadAccountPackageAlias({
			signal: abortController.signal,
			data: {
				packageId: params.packageId,
				search: location.searchStr,
			},
		}),
	notFoundComponent: NotFoundPage,
})
